import React, { useState } from 'react';
import CustomDatePicker from 'components/CustomDatePicker';
import { dialog } from '@microsoft/teams-js';
import PropTypes from 'prop-types';
import { Form } from '@fluentui/react-northstar';

const CelebrationDatesForm = ({ birthDate, anniversaryDate, setSubmitLoader }) => {
    const [dateOfBirth, setDateOfBirth] = useState(birthDate !== 'undefined' ? birthDate : null);
    const [dateOfJoining, setDateOfJoining] = useState(anniversaryDate !== 'undefined' ? anniversaryDate : null);

    const handleSubmit = () => {
        const data = {
            birthDate: birthDate === 'undefined' ? dateOfBirth : null,
            anniversaryDate: anniversaryDate === 'undefined' ? dateOfJoining : null,
        };
        setSubmitLoader(true);
        dialog.url.submit(
            { data: data, startedVia: 'messagingExtension', flagType: 'celebrations_datesModalSubmit' },
            process.env.REACT_APP_TEAMS_APP_ID
        );
    };

    const handleChange = ({ name, value }) => {
        switch (name) {
            case 'birthday':
                setDateOfBirth(value);
                break;
            case 'dateOfJoining':
                setDateOfJoining(value);
                break;
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <div className='celebration-modal-heading'>
                <span className='subheading'>From today, we're going to celebrate our special days together🥳</span>
                <div className='birthdate-wrapper'>
                    <label className='birthdate-label'>Please Select your birthdate (Optional)</label>
                    <CustomDatePicker
                        width='335px'
                        value={dateOfBirth}
                        onChange={(date) => handleChange({ name: 'birthday', value: date })}
                        placeholder='Select a date'
                        format='dd MMM yyyy'
                        disabled={birthDate !== 'undefined'}
                    />
                </div>
                <div className='joining-date-wrapper'>
                    <label className='joining-date-label'>Please add your date of joining (Optional)</label>
                    <CustomDatePicker
                        width='335px'
                        value={dateOfJoining}
                        onChange={(date) => handleChange({ name: 'dateOfJoining', value: date })}
                        placeholder='Select a date'
                        format='dd MMM yyyy'
                        disabled={anniversaryDate !== 'undefined'}
                    />
                </div>
            </div>
            <div className='modal-button-container'>
                <button
                    disabled={
                        !(dateOfBirth || dateOfJoining) ||
                        (birthDate !== 'undefined' && anniversaryDate !== 'undefined')
                    }
                >
                    Save dates
                </button>
            </div>
        </Form>
    );
};
CelebrationDatesForm.propTypes = {
    birthDate: PropTypes.string,
    anniversaryDate: PropTypes.string,
    setSubmitLoader: PropTypes.func,
};

export default CelebrationDatesForm;
